import { render, staticRenderFns } from "./Bankid.vue?vue&type=template&id=1e7cf9f1&"
import script from "./Bankid.vue?vue&type=script&lang=js&"
export * from "./Bankid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports